import Bugsnag from "@bugsnag/js";
import { capworksProgramService } from "@/modules/capworks/store/services/capworks-program-service";
import { LENDING_PROGRAM_RELATED_TAGS } from "@/features/LendingProgram/utils/lendingProgramServiceTags";
import { DEFAULT_NOTIFICATION_PAYLOAD, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import { ANALYTIC_EVENTS, sendAnalytics } from "@/utils/analytics";
import { showNotification } from "@/redux/actions/notification";
import { lenderHubDealService } from "@/features/LenderHub/Deal/store/services/lenderHubDealService";

const updateLendingProgramEndpoint = capworksProgramService.injectEndpoints({
  endpoints: (builder) => ({
    updateLendingProgram: builder.mutation({
      query: ({ lendingProgramId, ...body }) => ({
        url: `lending-programs/${lendingProgramId}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: LENDING_PROGRAM_RELATED_TAGS,
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          sendAnalytics(ANALYTIC_EVENTS.LENDING_PROGRAM_UPDATED, data);
          dispatch(
            showNotification({
              ...DEFAULT_NOTIFICATION_PAYLOAD,
              message: {
                ...DEFAULT_NOTIFICATION_PAYLOAD.message,
                description: "Lending Program have been updated!",
                options: { variant: NOTIFICATION_VARIANTS.SUCCESS },
              },
            }),
          );
          dispatch(lenderHubDealService.util.invalidateTags(["LenderHubDeal"]));
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useUpdateLendingProgramMutation } = updateLendingProgramEndpoint;

